export default __webpack_public_path__ + "static/media/ev-4.062f8ebc.png";